export default __webpack_public_path__ + "static/world-mobile-e46983ebbc775fbc35af926bc312722b.jpg";